/**
 * Helper Class for addin table events for icons, inputs and span.
 * Extends The Table Elements Helper Class.
 */
import TableElements from './TableElements';
export default class TableEvents extends TableElements {
    constructor() {
        super();
        this.timer = '';
    }

    /**
     * @description Make cell data editable
     * Adding event listener to elements (Span, icons && input)
     * @returns void
     */
    editableInputListener() {
        for (let item of document.querySelectorAll('.editable span')) {
            const inputId = item.parentNode.querySelector(`input`).getAttribute('id');
            const eventElements = ['.td_span', '.td_edit', '.td_undo'];

            for (let elementClass of eventElements) {
                this.sharedEventHandler({
                    item: item.parentNode,
                    id: item.parentNode.querySelector(elementClass).getAttribute('id'),
                    type: elementClass,
                    method: elementClass === '.td_undo' ? this.handleUndoEvent : this.handleEvents,
                });
            }

            this.inputEventHandler(inputId);
        }
    }

    /**
     * @description Event handling for edit icon and spans
     * Activate saving for input.
     * @param {Object} evt event object
     * @returns void
     */
    handleEvents(evt) {
        this.activateElement(evt.target.parentNode);
    }

    /**
     * @description Adding events
     * @param {Object} params {item, id, type & method callback}
     * @returns void
     */
    sharedEventHandler(params) {
        this.handleShared = params.method.bind(this);

        params.item
            .querySelector(`#${params.id}`)
            .addEventListener('click', this.handleShared, false);
    }

    /**
     * @description Handle event undo icon
     * @param {Object} evt event object
     * @returns void
     */
    handleUndoEvent(evt) {
        let initValue = evt.target.parentNode
            .querySelector('input')
            .getAttribute('data-init-value');

        evt.target.parentNode.querySelector('input').setAttribute('value', initValue);
        evt.target.parentNode.querySelector('input').value = initValue;
        evt.target.parentNode.querySelector('span').innerText = initValue;

        this.deActivateElement(evt.target.parentNode.getAttribute('id'));
        this.prepareSave(evt.target);
    }

    /**
     * @description Event for input element
     * Press: Preventing unfocus on input when typing
     * Keyup: Delay time with 1 second when typing, oterwise prepare saving
     * and deactivate element
     * Blur: Prepare saving and deactivate element
     * Keydown: Step, Up and down arrows for floats
     * @param {Object} item element || event
     * @returns void
     */
    inputEventHandler(item) {
        this.callbackKeyUp = this.handleKeyUp.bind(this);
        this.callbackPressDown = this.handleKeyPressKeyDown.bind(this);

        document.querySelector(`#${item}`).addEventListener('keypress', this.callbackPressDown);
        document.querySelector(`#${item}`).addEventListener('keydown', this.callbackPressDown);
        document.querySelector(`#${item}`).addEventListener('keyup', this.callbackKeyUp);
        document.querySelector(`#${item}`).addEventListener('blur', this.callbackKeyUp);
    }

    /**
     * @description Event Input Handle keyup
     * Set time out and set value to span element and input
     * @param {Object} evt event object
     * @returns void
     */
    handleKeyUp(evt) {
        this.timer = evt.target.getAttribute('id');
        const delayedTime = evt.type === 'blur' ? 0 : 1000;
        window.clearTimeout(this.timer);

        this.timer = window.setTimeout(() => {
            evt.target.parentNode.querySelector('span').innerHTML = evt.target.value;
            if (evt.target.value === '') {
                evt.target.value = evt.target.getAttribute('data-init-value');
            }

            evt.target.setAttribute('value', evt.target.value);
            this.deActivateElement(evt.target.parentNode.getAttribute('id'));
            this.prepareSave(evt.target);
        }, delayedTime);
    }

    /**
     * @description Event Input Handle keypress and keydown
     * Clear timeout when typing to keep focus on field when typing
     * @param {Object} evt object
     * @returns void
     */
    handleKeyPressKeyDown(evt) {
        window.clearTimeout(this.timer);
    }
}
